import React from 'react';
import { Tooltip } from "@mui/material";
import moment from "moment";

// Components
import AssignCard from "../../../pages/board/components/Kanban/AssignCard";
import EditTitle from "../../../pages/board/components/Kanban/EditTitle";
import CustomizedProgressBars from "../../../pages/board/components/progressBar/ProgressBar";
import CustomDateFormatter from "../../../pages/board/components/dateTimeFormateConverter/dateTimeFormateConverter";
import CardViewTooltip from "../../../pages/board/components/details/sidebar/components/subTask/CardViewTooltip";
import DueDate from "../../../pages/board/components/Kanban/DueDate";
import TodoChangeStatus from "../../../pages/board/components/Kanban/TodoChangeStatus";
import { EditIcone } from "../../UI/Icons";
import ParentCardKeys from './ParentCardKeys';
import BoardCardKey from './BoardCardKey';

// Icons/Images
import checkMark from "../../../styles/svg/checkMark.svg";
import mediumPriorityIcon from "../../../styles/svg/medium_priority.svg";
import highPriorityIcon from "../../../styles/svg/high_priority.svg";
import lowPriorityIcon from "../../../styles/svg/low_priority.svg";
import criticalPriorityIcon from "../../../styles/svg/critical_priority.svg";

// Utils
import { TooltipName } from "../../../utils/Enums";
import { useNavigate } from 'react-router-dom';
const getPriorityIcon = (priority) => {
  const priorityIcons = {
    Critical: criticalPriorityIcon,
    High: highPriorityIcon,
    Medium: mediumPriorityIcon,
    Low: lowPriorityIcon
  };
  return priorityIcons[priority] || "";
};

const CardContent = React.memo(
  ({
    provided = null,
    snapshot = null,
    project,
    boardName,
    isAssignedUser,
    style,
    isMyTaskCard,
    accessForChangeStatus,
    onDragEnd,
    handleDetails,
    tooltipName,
    name,
    accessForAssign,
    isTodo,
    checkOwnerOrAdmin,
    currentUser,
    accessForEditCard,
    isMobile,
    openEditField,
    isAssignee,
    boardId,
    openSubtask,
    isEditing,
    setIsEditing,
    collapsed,
    formatTimeFromNow,
    boardKey,
    isMyPlanner,
    boardPermission,
    is_card_collaborator,
  }) => {
    const isAssignedToCurrentUser = project?.card?.assigned_to_user?.user_id == currentUser?.user_id;
    console.log("isAssignedToCurrentUser", isAssignedToCurrentUser);
    return (
      <div
        className={`card-style display-card-icons draggable-card ${
          isMyPlanner ? "my-planner-card" : ""
        }`}
        {...(provided
          ? {
              ...provided.draggableProps,
              ...provided.dragHandleProps,
              ref: provided.innerRef,
            }
          : {})}
        onClick={handleDetails}

        {...(isMyTaskCard
          ? {
              draggable: accessForChangeStatus,
              onDragEnd: (e) => {
                onDragEnd(e, project?.card);
              },
            }
          : {})}
      >
        {!isMyPlanner && (
          <ParentCardKeys
            project={project}
            boardName={boardName}
            isAssignedUser={isAssignedUser}
            boardKey={boardKey}
            handleDetails={handleDetails}
            isMyTaskCard={isMyTaskCard}
          />
        )}

        <div className="d-flex justify-content-space-between">
          <div
            className={`d-flex align-items-center ${
              isAssignedUser ? "reverse-order-icons" : ""
            }`}
          >
            {/* {!isMyPlanner && ( */}
            <div className="avatar-container">
              {project?.assigned_user_last_seen && !isAssignedUser && (
                <Tooltip
                  title={
                    <CustomDateFormatter
                      date={project?.assigned_user_last_seen}
                    />
                  }
                  arrow
                >
                  <img
                    src={checkMark}
                    alt="checkMark"
                    className="cursor-pointer checkMark-position"
                  />
                </Tooltip>
              )}
              {!isAssignedUser && (
                <div>
                  <AssignCard
                    tooltipName={tooltipName}
                    project={project?.card}
                    name={name}
                    accessForAssign={(checkOwnerOrAdmin || isAssignedToCurrentUser || currentUser?.user_id == project?.card?.reporter || is_card_collaborator) || boardPermission?.can_reassign_user }
                    cardId={project?.card?.card_id}
                    isShowAssignedCards={true}
                    isTodo={isTodo}
                    accessForQuickTask={
                      project?.card?.todo_column !== "Accepted" &&
                      (checkOwnerOrAdmin ||
                        currentUser?.user_id == project?.card?.reporter)
                    }
                  />
                </div>
              )}
            </div>
            {/* )} */}
            <div
              className={` ml-1
              `}
            >
              <p className="d-flex align-items-center">
                <Tooltip title={`priority: ${project?.card?.priority}`}>
                  <img
                    className="priority_icon cursor-pointer"
                    src={getPriorityIcon(project?.card?.priority)}
                    alt="priority"
                  />
                </Tooltip>
                <BoardCardKey
                  project={project}
                  boardName={boardName}
                  isAssignedUser={isAssignedUser}
                  boardKey={boardKey}
                  handleDetails={handleDetails}
                />
              </p>
              {!isAssignedUser && (
                <p className={`related_time ${isMyPlanner ? "ml-1" : ""}`}>
                  {formatTimeFromNow(project?.card?.date_created)}
                </p>
              )}
            </div>
          </div>
          {isAssignedUser && (
            <p className={`related_time assigned-user-created-time`}>
              {formatTimeFromNow(project?.card?.date_created)}
            </p>
          )}
          <div className="d-flex align-items-center  card-icons-top-right">
            {!isMyPlanner &&
              accessForEditCard &&
              !isMobile &&
              !isAssignedUser && (
                <Tooltip title={TooltipName.KANBAN_CARD.EDIT_TASK_TITLE}>
                  <div
                    onClick={openEditField}
                    className="cursor-pointer edit-icon"
                  >
                    <EditIcone className="kanban-card-edit-icon" />
                  </div>
                </Tooltip>
              )}
            {isTodo && (
              <TodoChangeStatus
                status={project?.card?.todo_column}
                cardId={project?.card?.card_id}
                boardId={boardId}
                checkOwnerOrAdmin={checkOwnerOrAdmin}
                isAssignee={isAssignee}
                creator={currentUser?.user_id == project?.card?.reporter}
                reporterId={project?.card?.reporter}
                assignedUserId={project?.card?.assigned_to_user?.user_id}
              />
            )}
          </div>
        </div>

        {!isMyPlanner && (
          <div className="subtasks subtasks-uline ml-44">
            {project?.sub_tasks?.length > 0 &&
              project?.sub_tasks?.map((subtask) => (
                <Tooltip
                  key={`subTask-${subtask?.card.card_id}`}
                  title={
                    <CardViewTooltip
                      project={subtask}
                      boardName={boardName?.key || boardKey || project?.key}
                    />
                  }
                  arrow
                  placement="top"
                  enterNextDelay={1100}
                  disableInteractive
                  componentsProps={{
                    tooltip: {
                      sx: {
                        width: "320px",
                        maxWidth: "320px",
                        padding: 0,
                        borderRadius: 2,
                        boxShadow: 4,
                      },
                    },
                  }}
                  className="subtask-tooltip"
                >
                  <div className="subtask d-flex align-items-center justify-content-space-between">
                    <div className="w-70">
                      <span
                        className="related_time cursor-pointer"
                        onClick={(event) =>
                          openSubtask(event, subtask?.card.card_id)
                        }
                      >
                        {boardName?.key || boardKey || project?.key}-
                        {subtask?.card.card_id}
                      </span>
                    </div>
                    <div className="related_time w-38">
                      {subtask?.total_hours_spent !== null
                        ? subtask?.total_hours_spent
                        : 0}
                      /
                      {subtask?.card.allocated_hours !== null
                        ? subtask?.card.allocated_hours
                        : 0}
                    </div>
                    <div className="related_time w-23 d-flex justify-content-end">
                      {subtask?.card.allocated_hours &&
                      subtask?.total_hours_spent
                        ? Math.round(
                            (subtask?.total_hours_spent /
                              subtask?.card.allocated_hours) *
                              100
                          )
                        : 0}
                      %
                    </div>
                  </div>
                </Tooltip>
              ))}
          </div>
        )}

        <div className={`mt-2 `}>
          <EditTitle
            project={project}
            isEditing={isEditing}
            setIsEditing={setIsEditing}
            isCardTitle={true}
          />
        </div>

        {collapsed ? null : (
          <div>
            <strong>Description: </strong>
            {project?.card?.description}
            <br />
          </div>
        )}

        <div className="d-flex flex-wrap">
          {project?.labels?.[0] != "" && (
            <div className="d-flex flex-wrap">
              {project?.labels?.map((el, index) => (
                <div key={`${el}-${index}`} className="card-level-tag mr-1">
                  <p className="card-level-tag-text">{el}</p>
                </div>
              ))}
            </div>
          )}

          {project?.card?.epic && (
            <div className="d-flex">
              <div className="card-epic-tag mr-1">
                <p className="card-epic-tag-text">
                  {project?.card?.epic?.epic_name}
                </p>
              </div>
            </div>
          )}
        </div>

        {isTodo && !isMyTaskCard ? (
          project?.card.todo_column === "Open" ? (
            <DueDate date={project?.card?.due_date} />
          ) : null
        ) : (
          <CustomizedProgressBars
            allocatedHours={project?.card?.allocated_hours}
            hoursSpent={
              project?.total_hours_spent ? project?.total_hours_spent : 0
            }
            showOnCardOnBoard={true}
          />
        )}
      </div>
    );
  }
);

CardContent.displayName = 'CardContent';

export default CardContent; 